import MyLocale from '@/models/MyLocale.model';

export const al = new MyLocale({
	title: 'WB-CPP',

	word: {
		to: 'deri në',
	},
	message: {
    emptyState: {
      noData: {
        title: 'Asnjë e dhënë nuk u gjet!',
        message: 'Asnjë e dhënë nuk u gjet!',
      },
      unknownAuthor: {
        title: 'Autor i panjohur!',
        message: 'Autor i panjohur!',
      },
    },
	},
	filters: {
		dataType: {
			title: 'Vështrime klimatike sipas burimit të të dhënave',
      info: 'Eksploroni të dhënat e vëzhguara dhe skenarët e bazuar në modele për variablat kryesorë të klimës.',
			observation: {
				title: 'Historike',
			},
			scenario: {
				title: 'Skenari',
			},
      mapInfoTitle: 'Grupi i të dhënave',
		},
		variable: {
			title: 'Variabël',

			// New variables
			cdd5: 'cdd5',
			cdd7: 'cdd7',
			dhi5: 'dhi5',
			dhi7: 'dhi7',
			ews: 'ews',
			ewc: 'ewc',
			ftd: 'ftd',
			hd30: 'hd30',
			hd40: 'hd40',
			ls: 'ls',
			sdii: 'sdii',
			hs: 'hs',
			sd: 'sd',
			pr: 'pr',
			tmean: 'tmean',
			tasmax: 'tasmax',
			tasmin: 'tasmin',

			// Tooltips for new variables
			cdd5Tooltip: 'cdd5',
			cdd7Tooltip: 'cdd7',
			dhi5Tooltip: 'dhi5',
			dhi7Tooltip: 'dhi7',
			ewsTooltip: 'ews',
			ewcTooltip: 'ewc',
			ftdTooltip: 'ftd',
			hd30Tooltip: 'hd30',
			hd40Tooltip: 'hd40',
			lsTooltip: 'ls',
			sdiiTooltip: 'sdii',
			hsTooltip: 'hs',
			sdTooltip: 'sd',
			prTooltip: 'pr',
			tmeanTooltip: 'tmean',
			tasmaxTooltip: 'tasmax',
			tasminTooltip: 'tasmin',

			// Titles for new variables
			cdd5Title: 'Periudha të thata (5 ditë)',
			cdd7Title: 'Periudha të thata (7 ditë)',
			dhi5Title: 'Ditë të nxehta gjatë periudhave të thata (5 ditë)',
			dhi7Title: 'Ditë të nxehta gjatë periudhave të thata (7 ditë)',
			ewsTitle: 'Ekstreme të shpejtësisë së erës',
			ewcTitle: 'Ditë me shpejtësi ekstreme të erës',
			ftdTitle: 'Ciklet ngrirje-shkrirje',
			hd30Title: 'Ditë të nxehta (30 °C)',
			hd40Title: 'Ditë të nxehta (40 °C)',
			lsTitle: 'Kushtet kritike të reshjeve për rrëshqitje dheu',
			sdiiTitle: 'Ekstremet e reshjeve',
			hsTitle: 'Reshje të dendura bore',
			sdTitle: 'Reshje bore',
			prTitle: 'Sasia e reshjeve',
			tmeanTitle: 'Temperatura mesatare',
			tasmaxTitle: 'Temperatura maksimale',
			tasminTitle: 'Temperatura minimale',

      cdd5Description: 'Ditë në periudha të njëpasnjëshme 5-ditore me më pak se 1mm reshje gjatë prillit-shtatorit',
      cdd7Description: 'Ditë në periudha të njëpasnjëshme 7-ditore me më pak se 1mm reshje gjatë prillit-shtatorit',
      dhi5Description: 'Ditë në periudha të thata 5-ditore me temperaturë maksimale ditore mbi 30°C',
      dhi7Description: 'Ditë në periudha të thata 7-ditore me temperaturë maksimale ditore mbi 30°C',
      ewsDescription: '99.9 përqindëshi i shpejtësive mesatare ditore të erës në periudhën e vëzhguar 1981-2010',
      ewcDescription: 'Ditë që tejkalojnë 99.9 përqindëshin e shpejtësive mesatare ditore të erës në periudhën e vëzhguar 1981-2010',
      ftdDescription: 'Ditë me temperaturë minimale nën -2.2°C dhe maksimale mbi 0°C',
      hd30Description: 'Ditë me temperaturë maksimale mbi 30°C',
      hd40Description: 'Ditë me temperaturë maksimale mbi 40°C',
      lsDescription: 'Ditë që tejkalojnë pragjet e intensitetit të reshjeve sipas metodës Moser-Hohensinn (M = 41.66 * (h^-0.77) * h) për h = 24, 48 dhe 72 orë',
      sdiiDescription: '99.9 përqindëshi i sasisë ditore të reshjeve gjatë periudhave 30-vjeçare',
      hsDescription: 'Ditë me sasi reshjesh mbi 10mm dhe temperaturë mesatare nën 0°C',
      sdDescription: 'Ditë me sasi reshjesh mbi 1mm dhe temperaturë mesatare nën 0°C',
      prDescription: 'Sasia ditore e reshjeve',
      tmeanDescription: 'Temperatura mesatare ditore e ajrit',
      tasmaxDescription: 'Temperatura maksimale ditore e ajrit',
      tasminDescription: 'Temperatura minimale ditore e ajrit',

		},
		period: {
			title: 'Periudha',
      '1981-2010': '1981-2010',
      '2011-2040': '2011-2040',
      '2001-2020': '2001-2020',
      '2036-2065': '2036-2065',
      '2071-2100': '2071-2100',
		},
    scenario: {
      title: 'Skenari',
      ens: 'ENS',
      rcp26: 'RCP2.6 (skenar i ulët i emetimeve)',
      rcp45: 'RCP4.5 (skenar i moderuar i emetimeve)',
      rcp85: 'RCP8.5 (skenar i lartë i emetimeve)',
    },
		season: {
			title: 'Sezoni',
      'yr': 'Vjetore',
      '01': 'Janar',
      '02': 'Shkurt',
      '03': 'Mars',
      '04': 'Prill',
      '05': 'Maj',
      '06': 'Qershor',
      '07': 'Korrik',
      '08': 'Gusht',
      '09': 'Shtator',
      '10': 'Tetor',
      '11': 'Nëntor',
      '12': 'Dhjetor',
		},
		gwl: {
			title: 'Niveli i ngrohjes globale',
      '1.5': 'GWL1.5',
      '2.0': 'GWL2.0',
      '3.0': 'GWL3.0',
      '4.0': 'GWL4.0',
		},
		gridSpacing: {
			title: 'Hapësira e rrjetit',
      '01deg': '01deg',
		},
		author: {
      title: 'Autor',
      defaultLabel: 'Zgjidhni autorin',
    }
	},
	options: {
		download: {
			image: 'Imazhi',
			pdf: 'PDF',
			file: 'Skedar',
		},
	},
	legend: {
		min: 'min',
		max: 'max',
	},
	mapDetails: {
		value: 'Vlerë',

		ens: 'Mesatare',
		ens75: 'Përqindja e 75-të',
		ens25: 'Përqindja e 25-të',

    noCsvData: 'Nuk ka të dhëna csv për këtë pikë',
    subgridToggleLabel: 'Shfaq rrjetin 30arcsec',
    subgridToggleOnInfo: 'Aktivizimi i rrjetit 30arcsec për këtë qelizë do të tregojë gjithashtu rrjetin 30arcsec për të gjitha qelizat fqinje.',
    subgridToggleOffInfo: 'Zgjidhni një qelizë 30arcsec për të parë paraprakisht të dhënat e saj.',
	},
	tour: {
		closeButton: 'Close',
		backButton: 'Back',
		nextButton: 'Next',
		completeButton: 'Complete',
		startButton: 'Start platform tour',
	},
	unit: {
    Celsius: '°C',
		'%': '%',
		mm: 'mm',
    d: 'd',
    'm s-1': 'm s-1',
	},
  mapView: {
    noneValue: 'Pa hartë',
    terrain: 'Hartë terreni',
    satellite: 'Hartë satelitore',
  },
  mapOptions: {
    showClimateData: 'Shfaq të dhënat klimatike',
  },
  footer: {
    kosovoBorderLabel: 'Kjo përcaktim bëhet pa paragjykim ndaj qëndrimeve për statusin dhe është në përputhje me UNSCR 1244/99.',
  },
  nav: {
    map: 'Harta',
  },
});
